import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/broker/worker/');

const state = {
    ...current_module.state,
    columns: [
        // {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'Name', value: 'name', sortable: false, filterable: true, divider: true,},
        {text: 'UID', value: 'uid', sortable: false, filterable: true, divider: true,},
        {text: 'IP', value: 'ip', sortable: false, filterable: true, divider: true,},
        {text: 'Start time', value: 'start_time', sortable: false, filterable: true, divider: true, type: 'datetime'},
        {text: 'Number of processes', value: 'number_processes', sortable: false, filterable: true, divider: true,},
        {text: 'pool_length', value: 'pool_length', sortable: false, filterable: true, divider: true,},
        {text: 'Success', value: 'success_count', sortable: false, filterable: true, divider: true,},
        {text: 'Error', value: 'error_count', sortable: false, filterable: true, divider: true,},
        {text: 'CPU %', value: 'cpu_percent', sortable: false, filterable: true, divider: true,},
        {text: 'MEM %', value: 'mem_percent', sortable: false, filterable: true, divider: true,},
    ],
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['name'],
        sortDesc: [true],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        WorkerTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}